import {createRouter, createWebHashHistory, createWebHistory, createMemoryHistory} from 'vue-router'
import Home from '../views/Home.vue'
// import Model from '../views/00_Model.vue'
//import Help from "../views/Help";

const routes = [
    // Einstieg (Ladebildschirm)
    {
        path: '/',
        component: Home,
        meta: {
            title: 'Start'
        }
    },
    // Hilfe
    // {
    //     path: '/help',
    //     component: Help
    //     //component: () => import(/* webpackChunkName: "help" */ '../views/Help.vue')
    // },

    // // 3D Modell
    // {
    //     path: '/model',
    //     component: Model,
    //     meta: {
    //         title: 'Model'
    //     }
    // },
    // // 3D Modell mit TextBanner
    // {
    //     path: '/TextBanner',
    //     component: () => import(/* webpackChunkName: "textbanner" */ '../views/01_TextBanner.vue'),
    //     meta: {
    //         title: 'Text Banner'
    //     }
    // },
    // 3D Modell mit TextBanner und Hotspot

    // {
    //     path: '/Deutschland',
    //     component: () => import(/* webpackChunkName: "infobox" */ '../views/010_Deutschland.vue'),
    //     meta: {
    //         title: 'Deutschland'
    //     }
    // },


    {
        path: '/Bundeslaender',
        component: () => import(/* webpackChunkName: "infobox" */ '../views/020_Bundeslaender.vue'),
        meta: {
            title: 'Bundesländer'
        }
    },

    
    // Credits
    {
        path: '/Credits',
        component: () => import(/* webpackChunkName: "credits" */ '../views/030_Credits.vue'),
        meta: {
            title: 'Credits'
        }
    },

];

function getHistory()
{
    if (process.env.VUE_APP_ROUTER_MODE === 'hash')
    {
        return createWebHashHistory();
    }

    if (process.env.VUE_APP_ROUTER_MODE === 'history')
    {
        return createWebHistory();
    }

    return createMemoryHistory();
}

const router = createRouter({
    history: getHistory(),
    base: process.env.BASE_URL,
    routes
});

export default router
